import { __decorate } from "tslib";
import { Injectable } from '@angular/core';
import saveAs from 'file-saver';
import _ from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { SailsSocketService } from '../../sails-socket';
let DataUsageStoreService = class DataUsageStoreService {
    sails;
    _usages = new BehaviorSubject([]);
    _loading = new BehaviorSubject(false);
    _flatUsages;
    _startDate;
    _endDate;
    usages = this._usages.asObservable();
    loading = this._loading.asObservable();
    constructor(sails) {
        this.sails = sails;
    }
    loadUsageData(start, end) {
        this._loading.next(true);
        this._resetUsages();
        this._setDates(start, end);
        this.sails.get(`/equipmentdatausage/report?startDate=${this._startDate.toISOString()}&endDate=${this._endDate.toISOString()}`)
            .subscribe(({ data }) => {
            this._flatUsages = data;
            const tree = this._composeTree(data);
            this._usages.next(tree);
            this._loading.next(false);
        });
    }
    exportUsages(monthColumns) {
        const columns = [
            { field: 'org.name', header: 'Organization' },
            { field: 'site.name', header: 'Site' },
            { field: 'name', header: 'Router' },
            ...monthColumns
        ];
        const exportData = _.reduce(this._flatUsages, (acc, usage) => {
            const row = _.map(columns, (column) => {
                const data = _.get(usage, column.field, '');
                return `${data}`.replaceAll(',', ' ');
            })
                .join(',');
            acc.push(row);
            return acc;
        }, [_.map(columns, 'header').join(',')]);
        const dateRange = `${monthColumns[0].header} - ${monthColumns[monthColumns.length - 1].header}`;
        const blob = new Blob([exportData.join('\n')], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;'
        });
        saveAs(blob, `Data Usage Report_${dateRange}.csv`);
    }
    _setDates(start, end) {
        this._startDate = start;
        this._endDate = end;
    }
    _resetUsages() {
        this._usages.next([]);
    }
    _composeTree(routers) {
        const orgs = new Map();
        const sites = new Map();
        _.forEach(routers, (router) => {
            _.set(router, ['type'], 'Router');
            const orgId = router.org?.id;
            const siteId = router.site?.id || `${orgId}-N/A`;
            if (!sites.has(siteId)) {
                _.set(router, ['site', 'type'], 'Site');
                router.site.name = router.site.name || 'N/A';
                sites.set(siteId, {
                    data: router.site,
                    children: []
                });
            }
            if (!orgs.has(orgId)) {
                _.set(router, ['org', 'type'], 'Organization');
                orgs.set(orgId, {
                    data: router.org,
                    children: new Set() // use Set since this site could have been added by previous router entry
                });
            }
            const site = sites.get(siteId);
            const org = orgs.get(orgId);
            _.forEach(router.months, (total = 0, month) => {
                _.forEach([site, org], ({ data }) => {
                    const monthUsage = _.get(data, ['months', month], 0);
                    _.set(data, ['months', month], parseFloat((monthUsage + total).toFixed(2)));
                });
            });
            site.children.push({ data: router });
            if (!org.children.has(site)) {
                org.children.add(site);
            }
        });
        const tree = [];
        orgs.forEach((org) => {
            org.children = [...org.children]; // convert to array for TreeTable
            tree.push(org);
        });
        return tree;
    }
    static ctorParameters = () => [
        { type: SailsSocketService }
    ];
};
DataUsageStoreService = __decorate([
    Injectable({
        providedIn: 'root'
    })
], DataUsageStoreService);
export { DataUsageStoreService };
